"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var InteractionDescriptorRecord = (0, _immutable.Record)({
  type: null,
  icon: null,
  label: null,
  engagementType: null,
  onboardingAware: false,
  Component: null,
  wrappers: (0, _immutable.Seq)(),
  passthruRtePlugins: undefined,
  localTransforms: (0, _immutable.Seq)(),
  applicable: function applicable() {
    return true;
  }
}, 'InteractionDescriptorRecord');
var _default = InteractionDescriptorRecord;
exports.default = _default;
module.exports = exports.default;